import { StateInterface } from 'client/Interfaces/StateInterface'
import { createSelector } from 'reselect'

// typescript
import { subscriptionManagementSelector } from './'

// selectors

export const subscriptionCompanySelector = createSelector<
  StateInterface,
  StateInterface['subscriptionManagement'],
  StateInterface['subscriptionManagement']['companySubscription']
>(subscriptionManagementSelector, (subscriptionManagement) => subscriptionManagement.companySubscription)
